// const languages = {
//     "en": 'English',
//     "fr": 'French',
//     "de": 'German',
//     "nl": 'Dutch',
//     "es": 'Spanish',
//     "it": 'Italian',
//     "pt": 'Portuguese',
//     "pl": 'Polish',
//     "sv": 'Swedish',
//     "no": 'Norwegian',
//     "ru": 'Russian',
//     "ja": 'Japanese',
//     "zh": 'Chinese',
//     "ar": 'Arabic',
//     "af": 'Afrikaans',
// }

const languages = {
    "af":"Afrikaans",
    "sq":"Albanian",
    "am":"Amharic",
    "ar":"Arabic",
    "hy":"Armenian",
    "az":"Azerbaijani",
    "eu":"Basque",
    "be":"Belarusian",
    "bn":"Bengali",
    "bs":"Bosnian",
    "bg":"Bulgarian",
    "my":"Burmese",
    "ca":"Catalan",
    "ceb":"Cebuano",
    "zh":"Chinese (Simplified)",
    "zh-Hant":"Chinese (Traditional)",
    "hr":"Croatian",
    "cs":"Czech",
    "da":"Danish",
    "nl":"Dutch",
    "en":"English",
    "et":"Estonian",
    "fi":"Finnish",
    "fr":"French",
    "gl":"Galician",
    "ka":"Georgian",
    "de":"German",
    "el":"Greek",
    "gu":"Gujarati",
    "ha":"Hausa",
    "he":"Hebrew",
    "hi":"Hindi",
    "hu":"Hungarian",
    "is":"Icelandic",
    "ig":"Igbo",
    "id":"Indonesian",
    "ga":"Irish",
    "it":"Italian",
    "ja":"Japanese",
    "jw":"Javanese",
    "kn":"Kannada",
    "kk":"Kazakh",
    "km":"Khmer",
    "rw":"Kinyarwanda",
    "ko":"Korean",
    "ku":"Kurdish",
    "ky":"Kyrgyz",
    "lo":"Laothian",
    "lv":"Latvian",
    "lt":"Lithuanian",
    "mk":"Macedonian",
    "mg":"Malagasy",
    "ms":"Malay",
    "ml":"Malayalam",
    "mt":"Maltese",
    "mr":"Marathi",
    "mn":"Mongolian",
    "ne":"Nepali",
    "no":"Norwegian",
    "ps":"Pashto",
    "fa":"Persian",
    "pl":"Polish",
    "pt":"Portuguese",
    "pa":"Punjabi",
    "ro":"Romanian",
    "ru":"Russian",
    "sr":"Serbian",
    "si":"Sinhalese",
    "sk":"Slovak",
    "sl":"Slovenian",
    "so":"Somali",
    "es":"Spanish",
    "su":"Sundanese",
    "sw":"Swahili",
    "sv":"Swedish",
    "ta":"Tamil",
    "te":"Telugu",
    "th":"Thai",
    "ti":"Tigrinya",
    "tr":"Turkish",
    "uk":"Ukrainian",
    "ur":"Urdu",
    "uz":"Uzbek",
    "vi":"Vietnamese",
    "cy":"Welsh",
    "wo":"Wolof",
    "xh":"Xhosa",
    "yi":"Yiddish",
    "yo":"Yoruba",
    "zu":"Zulu"
};


const getLanguageLabel = (id) => {
    const label = languages[id];
    return label ? label.replace("--","").trim() : ""
}

export default languages;
export {getLanguageLabel};
